import { render } from "./TakeTime.vue?vue&type=template&id=72a824f8"
import script from "./TakeTime.vue?vue&type=script&lang=js"
export * from "./TakeTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__